module.exports = __webpack_public_path__ + "static/media/Developer-min.011daa95.svg";